import { render, staticRenderFns } from "./SEO.vue?vue&type=template&id=7ff6ccfa&"
import script from "./SEO.vue?vue&type=script&lang=js&"
export * from "./SEO.vue?vue&type=script&lang=js&"
import style0 from "./SEO.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports